// ============================================
// CONFIDENTIAL SECTION - Extrait de PropertyForm.jsx
// Étape 1.6: Intégration avec ctx
// Behavior: INCHANGÉ
// Note: Sera masquée si l'utilisateur n'a pas can_view_confidential
// ============================================
import React from 'react';

/**
 * Section Confidentiel du formulaire de bien
 * @param {Object} ctx - Contexte partagé
 */
const ConfidentialSection = ({ ctx }) => {
  const {
    formData,
    handleNestedChange,
    handleDeepNestedChange
  } = ctx;

  return (
    <div className="space-y-8">
      {/* Modern info header */}
      <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-red-500/5 via-orange-500/5 to-amber-500/10 border border-white/20 backdrop-blur-sm">
        <div className="absolute inset-0 bg-gradient-to-r from-red-600/10 to-orange-600/10"></div>
        <div className="relative p-6 flex items-center">
          <div className="w-16 h-16 bg-gradient-to-br from-red-500 to-orange-600 rounded-2xl flex items-center justify-center text-white mr-4 shadow-lg shadow-red-500/25">
            <i className="bi bi-shield-lock text-2xl"></i>
          </div>
          <div>
            <h2 className="text-2xl font-bold bg-gradient-to-r from-gray-800 to-red-600 bg-clip-text text-transparent">
              Informations Confidentielles
            </h2>
            <p className="text-gray-600 font-medium">
              Données sensibles (accès restreint)
            </p>
          </div>
        </div>
      </div>

      {/* Propriétaire */}
      <div className="bg-white rounded-2xl p-6 border border-gray-200">
        <h3 className="text-lg font-bold text-gray-800 mb-4 flex items-center">
          <i className="bi bi-person-badge mr-2 text-red-500"></i>
          Propriétaire
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2">Nom</label>
            <input
              type="text"
              value={formData.informations_confidentielles?.proprietaire?.nom || ''}
              onChange={(e) => handleDeepNestedChange && handleDeepNestedChange('informations_confidentielles', 'proprietaire', 'nom', e.target.value)}
              className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-red-500"
            />
          </div>
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2">Prénom</label>
            <input
              type="text"
              value={formData.informations_confidentielles?.proprietaire?.prenom || ''}
              onChange={(e) => handleDeepNestedChange && handleDeepNestedChange('informations_confidentielles', 'proprietaire', 'prenom', e.target.value)}
              className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-red-500"
            />
          </div>
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2">Téléphone</label>
            <input
              type="tel"
              value={formData.informations_confidentielles?.proprietaire?.telephone || ''}
              onChange={(e) => handleDeepNestedChange && handleDeepNestedChange('informations_confidentielles', 'proprietaire', 'telephone', e.target.value)}
              className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-red-500"
            />
          </div>
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2">Email</label>
            <input
              type="email"
              value={formData.informations_confidentielles?.proprietaire?.email || ''}
              onChange={(e) => handleDeepNestedChange && handleDeepNestedChange('informations_confidentielles', 'proprietaire', 'email', e.target.value)}
              className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-red-500"
            />
          </div>
        </div>
      </div>

      {/* Adresse exacte */}
      <div className="bg-white rounded-2xl p-6 border border-gray-200">
        <h3 className="text-lg font-bold text-gray-800 mb-4 flex items-center">
          <i className="bi bi-geo-alt-fill mr-2 text-red-500"></i>
          Adresse Exacte (Confidentielle)
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="md:col-span-2">
            <label className="block text-sm font-semibold text-gray-700 mb-2">Adresse</label>
            <input
              type="text"
              value={formData.informations_confidentielles?.adresse || ''}
              onChange={(e) => handleNestedChange('informations_confidentielles', 'adresse', e.target.value)}
              className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-red-500"
            />
          </div>
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2">Code postal</label>
            <input
              type="text"
              value={formData.informations_confidentielles?.code_postal || ''}
              onChange={(e) => handleNestedChange('informations_confidentielles', 'code_postal', e.target.value)}
              className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-red-500"
            />
          </div>
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2">Ville</label>
            <input
              type="text"
              value={formData.informations_confidentielles?.ville || ''}
              onChange={(e) => handleNestedChange('informations_confidentielles', 'ville', e.target.value)}
              className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-red-500"
            />
          </div>
        </div>
      </div>

      {/* Données financières */}
      <div className="bg-white rounded-2xl p-6 border border-gray-200">
        <h3 className="text-lg font-bold text-gray-800 mb-4 flex items-center">
          <i className="bi bi-graph-up-arrow mr-2 text-red-500"></i>
          Données Financières
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2">CA Annuel (€)</label>
            <input
              type="number"
              value={formData.informations_confidentielles?.chiffre_affaires_annuel || ''}
              onChange={(e) => handleNestedChange('informations_confidentielles', 'chiffre_affaires_annuel', parseFloat(e.target.value) || 0)}
              className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-red-500"
            />
          </div>
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2">Bénéfices Annuels (€)</label>
            <input
              type="number"
              value={formData.informations_confidentielles?.benefices_annuels || ''}
              onChange={(e) => handleNestedChange('informations_confidentielles', 'benefices_annuels', parseFloat(e.target.value) || 0)}
              className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-red-500"
            />
          </div>
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2">Charges Annuelles (€)</label>
            <input
              type="number"
              value={formData.informations_confidentielles?.charges_annuelles || ''}
              onChange={(e) => handleNestedChange('informations_confidentielles', 'charges_annuelles', parseFloat(e.target.value) || 0)}
              className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-red-500"
            />
          </div>
        </div>
      </div>

      {/* Raison de la vente */}
      <div className="bg-white rounded-2xl p-6 border border-gray-200">
        <h3 className="text-lg font-bold text-gray-800 mb-4 flex items-center">
          <i className="bi bi-chat-square-text mr-2 text-red-500"></i>
          Notes Confidentielles
        </h3>
        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-2">Raison de la vente</label>
          <textarea
            value={formData.informations_confidentielles?.raison_vente || ''}
            onChange={(e) => handleNestedChange('informations_confidentielles', 'raison_vente', e.target.value)}
            rows={3}
            className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-red-500"
            placeholder="Raison de la mise en vente..."
          />
        </div>
        <div className="mt-4">
          <label className="block text-sm font-semibold text-gray-700 mb-2">Commentaires confidentiels</label>
          <textarea
            value={formData.informations_confidentielles?.commentaires_confidentiels || ''}
            onChange={(e) => handleNestedChange('informations_confidentielles', 'commentaires_confidentiels', e.target.value)}
            rows={4}
            className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-red-500"
            placeholder="Notes et commentaires internes..."
          />
        </div>
      </div>
    </div>
  );
};

export default ConfidentialSection;
